'use client'

import Button, { ButtonProps } from '@mui/material/Button'
import { grey } from '@mui/material/colors'
import { styled } from '@mui/material/styles'
import { useTranslation } from 'react-i18next'

const SkipMenuButton = styled(Button)<ButtonProps>(({ theme }) => ({
  position: 'absolute',
  top: '-100%',
  left: '-100%',
  backgroundColor: theme.palette.background.default,
  color: theme.palette.text.primary,
  border: `2px solid ${theme.palette.text.primary}`,
  maxWidth: '55%',
  fontWeight: 'bold',
  '&:hover': {
    backgroundColor: grey[800]
  },
  '&:focus': {
    position: 'fixed',
    top: '1rem',
    left: '1rem',
    zIndex: theme.zIndex.tooltip
  },
  ':focus-visible': {
    position: 'fixed',
    top: theme.spacing(1),
    left: theme.spacing(1),
    zIndex: theme.zIndex.tooltip
  }
}))

export default () => {
  const { t } = useTranslation()

  const onClick = () => {
    const main = document.getElementById('main-content')
    if (main) {
      main.scrollIntoView()
      main.focus()
    }
  }

  return (
    <SkipMenuButton variant='contained' color='secondary' href='#main-content' onClick={onClick} disableRipple={true}>
      {t('Skip navigation')}
    </SkipMenuButton>
  )
}
